module.exports = __webpack_public_path__ + "img/plus_d5.906eda1c.png";